
import { ref, reactive, watch } from 'vue';

const key = 'history';

const store = ref( JSON.parse( sessionStorage.getItem( key ) ) || {} );

const actions = {

  saw: ( zipCode, tabId ) => {

    store.value[ `${ zipCode }-${ tabId }` ] = true;

  },

  seen: ( zipCode, tabId ) => store.value[ `${ zipCode }-${ tabId }` ],
  
  toJSON: () => store.value
  
};

watch( store, () => sessionStorage.setItem( key, JSON.stringify( store.value ) ), { deep: true, immediate: true } );

export default reactive( { store, ...actions } );
